module.exports = __webpack_public_path__ + "img/p6.7813d715.png";